import { Component, inject } from '@angular/core';
import { Router, RouterOutlet, Event, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, ActivatedRoute } from '@angular/router';
import * as tablerIcons from '@ng-icons/tabler-icons';
import * as tablerIconsFill from '@ng-icons/tabler-icons/fill';
import { provideIcons } from '@ng-icons/core';
import { ToastContainerComponent } from "./components/toast.component";
import { filter, map, mergeMap } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { MixpanelService } from '@core/services/mixpanel.services';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, ToastContainerComponent],
    template: `<router-outlet></router-outlet><app-toast-container></app-toast-container>`,
    viewProviders: [provideIcons({ ...tablerIcons, ...tablerIconsFill })]
})
export class AppComponent {

    private titleService = inject(Title)
    private router = inject(Router)
    private activatedRoute = inject(ActivatedRoute)
    private translate = inject(TranslateService);
    private mixpanel = inject(MixpanelService);

    ngOnInit(): void {
        this.mixpanel.init();

        this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd),
                map(() => {
                    let route = this.activatedRoute;
                    while (route.firstChild) {
                        route = route.firstChild;
                    }
                    return route;
                }),
                mergeMap(route => route.data)
            )
            .subscribe(data => {
                if (data['title']) {
                    this.translate.get(data['title']).subscribe(translated => {
                        this.titleService.setTitle(`${translated} | CCL Admin Dashboard`);
                    });
                }
            });
    }
}
